function getAllFocusable(el) {
    return Array.from(el.querySelectorAll(`
				a[href]:not([tabindex='-1']),
				area[href]:not([tabindex='-1']),
				input:not([disabled]):not([tabindex='-1']),
				select:not([disabled]):not([tabindex='-1']),
				textarea:not([disabled]):not([tabindex='-1']),
				button:not([disabled]):not([tabindex='-1']),
				iframe:not([tabindex='-1']),
				[tabindex]:not([tabindex='-1']),
				[contenteditable=true]:not([tabindex='-1'])
			`));
}
export default getAllFocusable;
